import { Directive, OnInit, inject, DestroyRef, WritableSignal, signal } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { merge, Observable } from 'rxjs';

@Directive({
  selector: 'mat-select[tdWbChipSelect]',
  host: {
    '[class.td-wb-chip-select]': 'true',
    '[class.td-wb-chip-select--selected]': 'valueSelected()'
  }
})
export class ChipSelectDirective implements OnInit {
  private readonly matSelect = inject(MatSelect);
  private readonly destroyRef = inject(DestroyRef);
  private readonly ngControl: NgControl | null = inject(NgControl, { optional: true, self: true });

  protected valueSelected: WritableSignal<boolean> = signal(false);

  ngOnInit(): void {
    const sources: Array<Observable<unknown>> = [this.matSelect.valueChange];
    if (this.ngControl?.valueChanges) {
      sources.push(this.ngControl.valueChanges);
    }

    merge(...sources)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.updateSelectedClasses();
      });

    this.updateSelectedClasses();
  }

  private updateSelectedClasses(): void {
    const value = this.ngControl?.value ?? this.matSelect.value;
    const selectedValues = Array.isArray(value)
      ? value
      : [value].filter((value: unknown) => value !== null && value !== undefined);

    this.valueSelected.set(selectedValues.length > 0);
  }
}